<section class="by-industry">
    <div id="Industries" class="section-name">
        <h6>By industry</h6>
        <div class="line"></div>
    </div>
    <div class="by-industry-wrapper">
        <div (click)="clickValueItem($event)" class="by-industry-items">
            <div class="row">
                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Aerospace.png" alt="Aerospace">
                        </div>
                        <h6 class="value-item-title">Aerospace</h6>
                    </div>
                    <div class="value-item-pop-up">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Aerospace</h5>
                            <p>Formal, documented testing is a critically important phase to ensure the quality and reliability of your mission-critical assets.
                                For decades, WorldERP® has provided expertise in custom software solutions, build management, and continuous automated testing with or
                                without IoT technologies in order to optimize test strategies and meet the ever increasing technical and business requirement demands.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Automotive.png" alt="Automotive">
                        </div>
                        <h6 class="value-item-title">Automotive</h6>
                    </div>
                    <div class="value-item-pop-up second">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Automotive</h5>
                            <p>Take advantage of WorldERP® solutions to accelerate innovation, boost brand awareness, drive growth through customer-
                                centric processes, reduce cost, and optimize supply-chain performance.</p>
                            <ul>
                                <li>Employ intelligent workflows to respond to rapid shifts in demand.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Banking.png" alt="Banking">
                        </div>
                        <h6 class="value-item-title">Banking</h6>
                    </div>
                    <div class="value-item-pop-up third">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Banking</h5>
                            <p>Leverage more robust solutions for traditional and legacy environments without sacrificing security or privacy
                                and engage a new generation of capabilities and improve operational efficiency.<br/><br/>
                                <i>Analytics</i><br/>
                                Gain extreme insight. Make the most of your data.<br/><br/>
                                <i>Financial Crime and AML Compliance</i><br/>
                                Gain insight on the latest misappropriation of funds, maverick spending, and boost compliance management.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Communications.png" alt="Communications, Media and Entertainment">
                        </div>
                        <h6 class="value-item-title">Communications,<br/> Media and Entertainment</h6>
                    </div>
                    <div class="value-item-pop-up fourth">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Communication, Media, and Entertainment</h5>
                            <p>Develop an agile enterprise cloud strategy. Multi-cloud is the new reality from open hybrid networks to platform
                                agility for media companies. Explore how to develop a personalized enterprise cloud strategy to engage the world.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Construction.png" alt="Construction and Engineering">
                        </div>
                        <h6 class="value-item-title">Construction and Engineering</h6>
                    </div>
                    <div class="value-item-pop-up">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Construction and Engineering</h5>
                            <p>Gain new powerful insights into Project Progress and Performance with AI.
                                Transform project management by delivering new levels of efficiency, visibility, collaboration, spend and change control.
                                </p>
                            <ul>
                                <li>Employ intelligent workflows to respond to rapid shifts in demand.</li>
                                <li>Leverage mobile devices to provide real-time status and updates for more accurate KPI</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Defense.png" alt="Defense & Intelligence">
                        </div>
                        <h6 class="value-item-title">Defense & Intelligence</h6>
                    </div>
                    <div class="value-item-pop-up second">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Defense & Intelligence</h5>
                            <p>Optimize your supply chain and gain new visibility into risks and opportunities while maximizing throughput.
                                Connect thousands of diverse systems and organizations world-wide into one platform for superior information fusion,
                                multinational logistics, joint theater logistics command & control, and improved joint deployment and rapid distribution
                                while leveraging Blockchain to provide a secure digital ecosystem to track parts and materials to know their origin.
                                </p>
                            <ul>
                                <li>Connect entities using dissimilar ERP and Financial Accounting Systems into one backbone using our proprietary Colony™
                                    technology to provide true Top-Down Command & Control exceeding JV2020 goals and objectives.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Education.png" alt="Education">
                        </div>
                        <h6 class="value-item-title">Education</h6>
                    </div>
                    <div class="value-item-pop-up third">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Education</h5>
                            <p>WorldERP® provides the best of modern management practices and state-of-the-art technology
                                to improve performance and cost savings. From benchmarking fiscal performance to student academics,
                                WorldERP® can not only help ensure your organization is getting the best value but show which school or entity is most efficient and effective. </p>
                            <ul>
                                <li>Improve attention and comprehension with the most effective solutions for distance learning on the market.
                                    Deliver an experience that engages and excites not just the students but the staff and faculty as well.</li>
                                <li>Leverage hyperconvergence and hyperautomation to achieve new levels of efficiency, visibility, time and spend management of contracts.</li>
                                <li>Leverage our portfolio of cooperative contracts, tools, and solutions that simplify the procurement process while maintaining compliance
                                    with Federal, State, and Local requirements.</li>
                                <li>Employ intelligent workflows to automatically ensure compliance.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/FoodBeverage.png" alt="Food and Beverage">
                        </div>
                        <h6 class="value-item-title">Food and Beverage</h6>
                    </div>
                    <div class="value-item-pop-up fourth">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Food and Beverage</h5>
                            <p>Get quotes from multiple suppliers with near instant turnaround by leveraging mobile devices and hyperautomation.</p>
                            <ul>
                                <li>Employ intelligent workflows to respond to rapid shifts in demand.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Government.png" alt="Government & Public Sector">
                        </div>
                        <h6 class="value-item-title">Government & Public Sector</h6>
                    </div>
                    <div class="value-item-pop-up">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Government & Public Sector</h5>
                            <p>Do more and achieve more while being fiscally responsible and transparent to the businesses and people you serve with our
                                hyperautomated and hyperconverged technology solutions.</p>
                            <ul>
                                <li>Enable secure remote access</li>
                                <li>Connect entities using dissimilar ERP and Financial Accounting Systems into one backbone using our exclusive Colony™
                                    technology without changing account code structures or formats, truly maximizing economies of scale and updating existing
                                    technologies with little to no capital expense.</li>
                                <li>Leverage hyperconvergence and hyperautomation to achieve new levels of efficiency, visibility, time, spend, and contract management.</li>
                                <li>Leverage our portfolio of cooperative contracts, tools, and solutions to simplify your sourcing and procurement process
                                    while maintaining compliance with Federal, State, and Local requirements.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Healthcare.png" alt="Healthcare">
                        </div>
                        <h6 class="value-item-title">Healthcare</h6>
                    </div>
                    <div class="value-item-pop-up second">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Healthcare</h5>
                            <p>Learn how we dramatically reduce costs up to 30% by innovating the latest solutions in sourcing and delivery through AI and hyperconvergence.<br/><br/>
                                WorldERP® empowers healthcare organizations with the industry’s most advanced and complete supply chain and ERP cloud solutions.</p>
                            <ul>
                                <li>Leverage hyperconvergence and hyperautomation to achieve new levels of efficiency, visibility, time, spend, and contract management.</li>
                                <li>Employ intelligent workflows to respond to rapid shifts in demand.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Hospitality.png" alt="Hospitality">
                        </div>
                        <h6 class="value-item-title">Hospitality</h6>
                    </div>
                    <div class="value-item-pop-up third">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Hospitality</h5>
                            <p>Get quotes from multiple suppliers of goods and services with near instant turnaround by leveraging mobile devices and hyperautomation.</p>
                            <ul>
                                <li>Connect entities using dissimilar ERP and Financial Accounting Systems into one backbone using our exclusive Colony™ technology without changing account code
                                    structures or formats, truly maximizing economies of scale and updating existing technologies with little to no capital expense.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Legal.png" alt="Legal">
                        </div>
                        <h6 class="value-item-title">Legal</h6>
                    </div>
                    <div class="value-item-pop-up fourth">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Legal</h5>
                            <p>Take invoicing and payment management to the next level with hyperautomation.</p>
                            <ul>
                                <li>Automatically provide payment and manage payment options right from the start for guaranteed, hassle free payment.</li>
                                <li>Automatically invoice clients and management non-payments.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Manufacturing.png" alt="Manufacturing">
                        </div>
                        <h6 class="value-item-title">Manufacturing</h6>
                    </div>
                    <div class="value-item-pop-up">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Manufacturing</h5>
                            <p>Meet your business challenges with hyperconverged and hyperautomation technology and cloud business solutions that will streamline costs and improve productivity.</p>
                            <ul>
                                <li>IoT technology interfaces</li>
                                <li>Employ intelligent workflows to respond to rapid shifts in demand.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/PlaceOfWorship.png" alt="Places of Worship">
                        </div>
                        <h6 class="value-item-title">Places of Worship</h6>
                    </div>
                    <div class="value-item-pop-up second">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Places of Worship</h5>
                            <p>Supplement your programs and services with professional Live Streaming, Webinar, Video sharing and Multilingual capability.</p>
                            <ul>
                                <li>Make filing tax returns as simple as clicking a button with our integrated QuickBooks technologies and reduce hours to seconds.</li>
                                <li>Leverage our portfolio of cooperative contracts, tools, and solutions to simplify your sourcing and procurement process while maintaining
                                    compliance with Federal, State, and Local requirements.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Cart.png" alt="Retail and e-Commerce">
                        </div>
                        <h6 class="value-item-title">Retail and e-Commerce</h6>
                    </div>
                    <div class="value-item-pop-up third">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Retail and e-Commerce</h5>
                            <p>Provide unprecedented agility to protect the brand experience, people, and profits.</p>
                            <ul>
                                <li>Use our hyperconverged and hyperautomation technologies to help you minimize the impact of events on your supply chain.</li>
                                <li>Employ intelligent workflows to respond to rapid shifts in demand.</li>
                                <li>Let artificial intelligence help you deliver marketing messages and offers tailored to your customer base.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-12 value">
                    <div class="value-item">
                        <div class="value-item-img-wrapper">
                            <img class="value-item-img" src="../../../assets/solutions/industry/Utilities.png" alt="Utiliies, Oil & Gas">
                        </div>
                        <h6 class="value-item-title">Utilities, Oil & Gas</h6>
                    </div>
                    <div class="value-item-pop-up fourth">
                        <div class="close">X</div>
                        <div class="value-item-text">
                            <h5>Utilities, Oil & Gas</h5>
                            <p>Extend ERP capabilities with our hyperconverged and hyperautomation technologies while utilizing IoT and
                                cloud-based applications to provide necessary and valuable insights, maximizing productivity and efficiency.</p>
                            <ul>
                                <li>Employ intelligent workflows to respond to rapid shifts in demand.</li>
                                <li>Let artificial intelligence help you deliver production messages and make operational decisions.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
